var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "vx-card",
    { attrs: { title: "SSR", "code-toggler": "" } },
    [
      _c("p", [
        _vm._v("To create table with SSR support just add "),
        _c("code", [_vm._v("sst")]),
        _vm._v(
          " prop and then handle appropriate events like searching, sorting & pagination."
        ),
      ]),
      _c(
        "vs-table",
        {
          attrs: {
            sst: true,
            pagination: "",
            "max-items": "3",
            search: "",
            data: _vm.users,
          },
          on: {
            search: _vm.handleSearch,
            "change-page": _vm.handleChangePage,
            sort: _vm.handleSort,
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ data }) {
                return _vm._l(data, function (tr, indextr) {
                  return _c(
                    "vs-tr",
                    { key: indextr, attrs: { data: tr } },
                    [
                      _c("vs-td", { attrs: { data: data[indextr].email } }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(data[indextr].email) +
                            "\n              "
                        ),
                      ]),
                      _c("vs-td", { attrs: { data: data[indextr].username } }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(data[indextr].username) +
                            "\n              "
                        ),
                      ]),
                      _c("vs-td", { attrs: { data: data[indextr].id } }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(data[indextr].website) +
                            "\n              "
                        ),
                      ]),
                      _c("vs-td", { attrs: { data: data[indextr].id } }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(data[indextr].id) +
                            "\n              "
                        ),
                      ]),
                    ],
                    1
                  )
                })
              },
            },
          ]),
          model: {
            value: _vm.selected,
            callback: function ($$v) {
              _vm.selected = $$v
            },
            expression: "selected",
          },
        },
        [
          _c("template", { slot: "header" }, [_c("h3", [_vm._v("Users")])]),
          _c(
            "template",
            { slot: "thead" },
            [
              _c("vs-th", { attrs: { "sort-key": "email" } }, [
                _vm._v("Email"),
              ]),
              _c("vs-th", { attrs: { "sort-key": "username" } }, [
                _vm._v("Name"),
              ]),
              _c("vs-th", { attrs: { "sort-key": "website" } }, [
                _vm._v("Website"),
              ]),
              _c("vs-th", { attrs: { "sort-key": "id" } }, [_vm._v("Nro")]),
            ],
            1
          ),
        ],
        2
      ),
      _c("prism", { staticClass: "rounded-lg" }, [
        _vm._v("\n" + _vm._s(_vm.log.join("\n")) + "\n        "),
      ]),
      _c("template", { slot: "codeContainer" }, [
        _vm._v(
          '\n<template>\n    <vs-table\n      :sst="true"\n      @search="handleSearch"\n      @change-page="handleChangePage"\n      @sort="handleSort"\n      v-model="selected"\n      pagination\n      max-items="3"\n      search\n      :data="users">\n\n        <template slot="header">\n            <h3>Users</h3>\n        </template>\n\n        <template slot="thead">\n            <vs-th sort-key="email">Email</vs-th>\n            <vs-th sort-key="username">Name</vs-th>\n            <vs-th sort-key="website">Website</vs-th>\n            <vs-th sort-key="id">Nro</vs-th>\n        </template>\n\n        <template slot-scope="{data}">\n            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">\n                <vs-td :data="data[indextr].email">\n                    ' +
            _vm._s("{{ data[indextr].email }}") +
            '\n                </vs-td>\n                <vs-td :data="data[indextr].username">\n                    ' +
            _vm._s("{{ data[indextr].username }}") +
            '\n                </vs-td>\n                <vs-td :data="data[indextr].id">\n                    ' +
            _vm._s("{{ data[indextr].website }}") +
            '\n                </vs-td>\n                <vs-td :data="data[indextr].id">\n                    ' +
            _vm._s("{{ data[indextr].id }}") +
            '\n                </vs-td>\n            </vs-tr>\n        </template>\n    </vs-table>\n</template>\n\n<script>\nexport default {\n  data:()=>({\n    selected:[],\n    log: [],\n    users:[\n      {\n        "id": 1,\n        "name": "Leanne Graham",\n        "username": "Bret",\n        "email": "Sincere@april.biz",\n        "website": "hildegard.org",\n      },\n      {\n        "id": 2,\n        "name": "Ervin Howell",\n        "username": "Antonette",\n        "email": "Shanna@melissa.tv",\n        "website": "anastasia.net",\n      },\n      {\n        "id": 3,\n        "name": "Clementine Bauch",\n        "username": "Samantha",\n        "email": "Nathan@yesenia.net",\n        "website": "ramiro.info",\n      },\n      {\n        "id": 4,\n        "name": "Patricia Lebsack",\n        "username": "Karianne",\n        "email": "Julianne.OConner@kory.org",\n        "website": "kale.biz",\n      },\n      {\n        "id": 5,\n        "name": "Chelsey Dietrich",\n        "username": "Kamren",\n        "email": "Lucio_Hettinger@annie.ca",\n        "website": "demarco.info",\n      },\n      {\n        "id": 6,\n        "name": "Mrs. Dennis Schulist",\n        "username": "Leopoldo_Corkery",\n        "email": "Karley_Dach@jasper.info",\n        "website": "ola.org",\n      },\n      {\n        "id": 7,\n        "name": "Kurtis Weissnat",\n        "username": "Elwyn.Skiles",\n        "email": "Telly.Hoeger@billy.biz",\n        "website": "elvis.io",\n      },\n      {\n        "id": 8,\n        "name": "Nicholas Runolfsdottir V",\n        "username": "Maxime_Nienow",\n        "email": "Sherwood@rosamond.me",\n        "website": "jacynthe.com",\n      },\n      {\n        "id": 9,\n        "name": "Glenna Reichert",\n        "username": "Delphine",\n        "email": "Chaim_McDermott@dana.io",\n        "website": "conrad.com",\n      },\n      {\n        "id": 10,\n        "name": "Clementina DuBuque",\n        "username": "Moriah.Stanton",\n        "email": "Rey.Padberg@karina.biz",\n        "website": "ambrose.net",\n      }\n    ]\n  }),\n  methods:{\n    handleSearch(searching) {\n      console.log(`The user searched for: ${searching}`)\n    },\n    handleChangePage(page) {\n      console.log(`The user changed the page to: ${page}`)\n    },\n    handleSort(key, active) {\n      console.log(`the user ordered: ${key} ${active}`)\n    }\n  }\n}\n</script>\n        '
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }